import { ProFormText, ProForm } from "@ant-design/pro-components";
import { FilterParams } from "@/facilities/model/user";
import { Col, Row } from "antd";

const GroupTexts = ({ fields }: { fields: FilterParams }) => {
  const { field, label, keys, fieldProps, placeholder, labelCol, wrapperCol } =
    fields;
  return (
    <ProForm.Item noStyle key={field} shouldUpdate>
      {(form: any) => {
        if (!keys) return;
        const getInputVals = (sum: number) => {
          let isdel = true;
          for (let index = 0; index < sum; index++) {
            if (form?.getFieldValue([keys[sum - 1]])) {
              isdel = false;
            }
          }
          return isdel;
        };
        const clearInput = (sum: number) => {
          const obj: any = {};
          for (let index = sum; index < keys.length; index++) {
            const k = keys[index];
            obj[k] = "";
          }
          form?.setFieldsValue(obj);
        };
        return (
          <Row className={`w-80 mr-3 ${fieldProps?.divClass}`}>
            <Col span={2} {...labelCol}>
              <span className="mr-2 leading-8">{label}:</span>
            </Col>
            <Col
              span={22}
              {...wrapperCol}
              className="flex justify-between items-center gap-1.5"
            >
              {keys?.map((item, index) => {
                return (
                  <ProFormText
                    key={`${field}.${item}`}
                    name={item}
                    noStyle
                    disabled={index === 0 ? false : getInputVals(index)}
                    placeholder={
                      placeholder ? placeholder[index] : item?.toUpperCase()
                    }
                    fieldProps={{
                      allowClear: false,
                      onChange: (val) => {
                        if (val.target.value.includes("-")) {
                          const obj: any = {};
                          const vals = val.target.value.split("-");
                          keys.map(
                            (k, index) => (obj[k] = vals[index]?.trim())
                          );
                          form?.setFieldsValue(obj);
                        }
                        fieldProps?.onChange?.(val.target.value, item);
                        if (!val.target.value) {
                          clearInput(index);
                        }
                      },
                    }}
                  />
                );
              })}
            </Col>
          </Row>
        );
      }}
    </ProForm.Item>
  );
};

export default GroupTexts;
